import { addLocaleData } from "react-intl";
import PropTypes from "prop-types";
import localeCs from "react-intl/locale-data/cs";
import localeDa from "react-intl/locale-data/da";
import localeDe from "react-intl/locale-data/de";
import localeEn from "react-intl/locale-data/en";
import localeEs from "react-intl/locale-data/es";
import localeFi from "react-intl/locale-data/fi";
import localeFr from "react-intl/locale-data/fr";
import localeHu from "react-intl/locale-data/hu";
import localeIt from "react-intl/locale-data/it";
import localeNl from "react-intl/locale-data/nl";
import localeNo from "react-intl/locale-data/no";
import localePl from "react-intl/locale-data/pl";
import localePt from "react-intl/locale-data/pt";
import localeRo from "react-intl/locale-data/ro";
import localeRu from "react-intl/locale-data/ru";
import localeSk from "react-intl/locale-data/sk";
import localeSv from "react-intl/locale-data/sv";
import localeUk from "react-intl/locale-data/uk";
import localeSl from "react-intl/locale-data/sl";
import localeHr from "react-intl/locale-data/hr";

import beFr from "./be-fr";
import beNl from "./be-nl";
import cs from "./cs";
import da from "./da";
import deAt from "./de-at";
import deCh from "./de-ch";
import de from "./de";
import en from "./en";
import es from "./es";
import fi from "./fi";
import frCh from "./fr-ch";
import fr from "./fr";
import hu from "./hu";
import itCh from "./it-ch";
import it from "./it";
import nl from "./nl";
import no from "./no";
import pl from "./pl";
import pt from "./pt";
import ro from "./ro";
import ru from "./ru";
import sk from "./sk";
import sv from "./sv";
import uk from "./uk";
import sl from "./sl";
import hr from "./hr";

addLocaleData([
  ...localeCs,
  ...localeDa,
  ...localeDe,
  ...localeEn,
  ...localeEs,
  ...localeFi,
  ...localeFr,
  ...localeHu,
  ...localeIt,
  ...localeNl,
  ...localePl,
  ...localePt,
  ...localeNo,
  ...localeRo,
  ...localeRu,
  ...localeSk,
  ...localeSv,
  ...localeUk,
  ...localeSl,
  ...localeHr,
]);

export default {
  "cs-CZ": cs,
  "da-DK": da,
  "de-AT": deAt,
  "de-DE": de,
  "de-CH": deCh,
  "en-GB": en,
  "pt-ES": pt,
  "es-ES": es,
  "fr-BE": beFr,
  "fr-CH": frCh,
  "fr-FR": fr,
  "fi-FI": fi,
  "hu-HU": hu,
  "it-CH": itCh,
  "it-IT": it,
  "nl-BE": beNl,
  "nl-NL": nl,
  "no-NO": no,
  "pl-PL": pl,
  "ro-RO": ro,
  "ru-RU": ru,
  "sk-SK": sk,
  "sv-FI": sv,
  "sv-SE": sv,
  "uk-UA": uk,
  "sl-SI": sl,
  "hr-HR": hr,
};

export const LocaleShape = PropTypes.shape({
  language: PropTypes.string.isRequired,
  region: PropTypes.string.isRequired,
});
